import React from 'react';
import SingleSelectFilter from './SingleSelectFilter';

const defaultOptions = [
  { id: 'open', name: 'Open' },
  { id: 'closed', name: 'Closed' },
];

export default function PrepaymentStatusFilter({
  placeholder = 'Prepayment Status',
  name,
  value,
  onChange,
  options = defaultOptions,
}) {
  return (
    <SingleSelectFilter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.name}
      options={options}
      onChange={onChange}
    />
  );
}
